import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedComparisonScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedComparisonScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  searchFilterData?: any;
}

const useFetchPaginatedComparisonScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  searchFilterData,
}: IuseFetchPaginatedComparisonScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const statusFilter = searchFilterData?.status_filter;
      const isActive =
        statusFilter === "Active"
          ? true
          : statusFilter === "Inactive"
            ? false
            : undefined;
      const ruleId = searchFilterData?.rule_id
        ? Number(searchFilterData.rule_id)
        : undefined;
      const result = await getPaginatedComparisonScoringConfigs({
        page,
        pSize,
        ruleId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, setIsLoading, searchFilterData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedComparisonScoringConfigs;

